import type { ApiError } from '../types/api.types';
// Re-export so consumers can use the same type
export type { ApiError };

export function normaliseApiError(error: unknown): ApiError {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { data?: unknown; status?: number } };
    const status = axiosError.response?.status ?? 500;
    const data = axiosError.response?.data as Record<string, unknown> | undefined;

    if (data && typeof data === 'object') {
      let message = 'Something went wrong';
      const rawMessage = data.message;

      if (typeof rawMessage === 'string') {
        message = rawMessage;
      } else if (Array.isArray(rawMessage) && rawMessage.length > 0) {
        message = rawMessage[0] as string;
      }

      let field_errors: Record<string, string> | undefined;
      const errors = data.errors;
      if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
        field_errors = errors as Record<string, string>;
      }

      const code = typeof data.code === 'string' ? data.code : undefined;
      const error_code = typeof data.error_code === 'string' ? data.error_code : undefined;
      const error = typeof data.error === 'string' ? data.error : undefined;

      const raw_ta = data.token_analysis;
      const token_analysis =
        raw_ta &&
        typeof raw_ta === 'object' &&
        !Array.isArray(raw_ta) &&
        Array.isArray((raw_ta as any).detected)
          ? (raw_ta as ApiError['token_analysis'])
          : undefined;

      return { message, statusCode: status, code, field_errors, error_code, error, token_analysis };
    }

    return { message: 'Something went wrong', statusCode: status };
  }

  if (error instanceof Error) {
    return { message: error.message, statusCode: 0 };
  }

  return { message: 'Something went wrong', statusCode: 0 };
}
